// Display and entry format. DD/MM/YYYY is ambiguous for US fleets — 03/04/2026
// reads as March 4 but meant 3 April — so dates are shown the way they are stored.
export const FORMAT_DATE = "YYYY-MM-DD";
export const FORMAT_ISO_DATE = "YYYY-MM-DD";
